var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 1.91382V2.45288L5.65625 5.75757C6.14844 6.15601 6.82812 6.15601 7.32031 5.75757L8.51562 4.77319C8.21094 5.33569 8.02344 5.99194 8 6.67163C7.08594 7.37476 5.82031 7.35132 4.92969 6.62476L1.625 3.90601V7.91382C1.625 8.12476 1.78906 8.28882 2 8.28882H8.25781C8.42188 8.71069 8.65625 9.08569 8.9375 9.41382H2C1.15625 9.41382 0.5 8.75757 0.5 7.91382V1.91382C0.5 1.09351 1.15625 0.413818 2 0.413818H11C11.8203 0.413818 12.5 1.09351 12.5 1.91382V2.68726C12.3594 2.68726 12.2422 2.66382 12.125 2.66382C11.6562 2.66382 11.2344 2.73413 10.8359 2.87476L11.375 2.45288V1.91382C11.375 1.72632 11.1875 1.53882 11 1.53882H2C1.78906 1.53882 1.625 1.72632 1.625 1.91382ZM15.5 6.78882C15.5 8.66382 13.9766 10.1638 12.125 10.1638C10.25 10.1638 8.75 8.66382 8.75 6.78882C8.75 4.93726 10.25 3.41382 12.125 3.41382C13.9766 3.41382 15.5 4.93726 15.5 6.78882ZM13.1562 5.78101L11.75 7.21069L11.0703 6.53101C10.9297 6.39038 10.6719 6.39038 10.5312 6.53101C10.3906 6.67163 10.3906 6.92944 10.5312 7.07007L11.4688 8.00757C11.6094 8.14819 11.8672 8.14819 12.0078 8.00757L13.6953 6.32007C13.8359 6.17944 13.8359 5.92163 13.6953 5.78101C13.5547 5.64038 13.2969 5.64038 13.1562 5.78101Z",
    fill: "#1A2849"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.ed8429872d2aa4744ce581909bfc4d95.svg";
export { ForwardRef as ReactComponent };